import { AnalysisSet } from "../ars_ldm";
import { isNamedObject } from "./isNamedObject";
import { isObjectRecord } from "./isObjectRecord";
import { isWhereClause } from "./isWhereClause";

/**
 * Type guard to check if a value is an AnalysisSet.
 *
 * Validates that the object has the required properties of an AnalysisSet:
 * - Extends NamedObject (name, description?, label?)
 * - Extends WhereClause (level, order, condition?, compoundExpression?)
 * - Has an id string
 *
 * @param obj - The value to check
 * @returns True if the value is an AnalysisSet, false otherwise
 */
export const isAnalysisSet = (obj: unknown): obj is AnalysisSet => {
  if (!isObjectRecord(obj)) return false;
  // Check NamedObject and WhereClause
  if (!isNamedObject(obj) || !isWhereClause(obj)) return false;
  // Check id
  if (typeof obj.id !== "string") return false;
  // Everything is good
  return true;
};
